// FAQ.js
import React, { useState } from "react";
import "./FAQ.css"; // Make sure to create a CSS file for styling

const faqData = {
  "What is the purpose of the StakingContract?":
    "The StakingContract allows users to stake ERC20 tokens to earn rewards based on the staking duration. Users can stake tokens for 1, 3, 6, or 12 months and earn rewards accordingly. Early withdrawals incur a penalty.",
  "How can I stake my tokens?":
    "To stake your tokens, call the stake function with the desired amount and duration (1, 3, 6, or 12 months). Ensure you have approved the contract to spend your tokens before calling this function.",
  "What are the reward rates for different staking durations?":
    "The reward rates are as follows:\n\n12 months: 43%\n6 months: 33%\n3 months: 23%\n1 month: 13%",
  "Is there a penalty for early unstaking?":
    "Yes, if you unstake before the end of your chosen duration, a penalty of 10% of the staked amount is applied. The penalty rate may vary based on the remaining time.",
  "How can I claim my rewards?":
    "To claim your rewards, call the claimReward function. You can claim rewards after each reward claim period (30 days) from the last claim time.",
  "What happens in case of an emergency?":
    "In case of an emergency, you can call the emergencyWithdraw function to withdraw your staked tokens immediately. This function can only be called when the contract is paused.",
  "How are rewards calculated?":
    "Rewards are calculated based on the staked amount, duration, and the reward rate for that duration. The calculateReward function determines the total reward accumulated, including any previously accumulated rewards.",
  "What is the maximum amount I can stake?":
    "The maximum stake amount is 1,000,000 tokens (1,000,000 * 10^18).",
};

const FAQ = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const toggleQuestion = (question) => {
    setSelectedQuestion(selectedQuestion === question ? null : question);
  };

  return (
    <div className="faq">
      <h1>FAQ</h1>
      <div className="faq-list">
        {Object.keys(faqData).map((question, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleQuestion(question)}
            >
              {question}
              <span>{selectedQuestion === question ? "-" : "+"}</span>
            </div>
            {selectedQuestion === question && (
              <div className="faq-answer">{faqData[question]}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
